import { Switch } from 'react-router-dom';
import InterestAccountsPage from './InterestAccountsPage';
import { usePermissions } from '@/providers/Permissions.provider';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';

const Routes = () => {
  const { permissions } = usePermissions();
  const lockedFeatures = useLockedFeatures();

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={
          (!!permissions.ManageInterestAccounts || !!permissions.ViewInterestAccounts) &&
          !!lockedFeatures.InterestAccountEnabled
        }
        showPermission
        exact
        path="/interest-accounts"
        component={InterestAccountsPage}
      />
    </Switch>
  );
};

export default Routes;
